<template>
  <router-link
    :to="to"
    :class="[
      'o-link-arrow',
      { 'back': back },
      { 'o-link-reverse': darkMode },
      { 'disabled': disabled },
      { 'no-decoration': !decoration },
      { 'ob1-link-dark': black }
    ]">
    {{ label }}
    <span
      v-if="srLabel"
      class="sr-only">
      {{ srLabel }}
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'ArrowLink',
  props: {
    label: {
      type: String,
      required: true
    },
    to: {
      type: [Object, String],
      required: true
    },
    srLabel: {
      type: String,
      default: null
    },
    decoration: {
      type: Boolean,
      default: true
    },
    back: {
      type: Boolean,
      default: false
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    black: {
      type: Boolean,
      default: false
    }
  }
}
</script>
